import { create } from 'zustand';

type LocationHistoryState = {
  previousPath?: string;
};

type LocationHistoryActions = {
  setPreviousPath: (path: string) => void;
};

export const useLocationHistoryStore = create<LocationHistoryState & LocationHistoryActions>((set) => ({
  previousPath: undefined,
  setPreviousPath: (path: string) => {
    set({ previousPath: path });
  },
}));

export const locationHistoryStoreActions = {
  setPreviousPath: (path: string) => {
    useLocationHistoryStore.getState().setPreviousPath(path);
  },
} as const;
